const DEFAULT_WHITEBOARD_PREFS = {
  color: "#f59e0b",
  penSize: 5,
  highlighterSize: 14,
  boardSurface: "default",
  gridEnabled: true,
};

const BOARD_SURFACE_OPTIONS = new Set(["default", "white", "black"]);

function clamp(value, min, max, fallback) {
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  return Math.max(min, Math.min(max, Math.round(num)));
}

export function normalizeWhiteboardPrefs(source) {
  const raw = source && typeof source === "object" ? source : {};
  const color = String(raw.color || "").trim();
  return {
    color: /^#[0-9a-fA-F]{6}$/.test(color) ? color : DEFAULT_WHITEBOARD_PREFS.color,
    penSize: clamp(raw.penSize, 2, 24, DEFAULT_WHITEBOARD_PREFS.penSize),
    highlighterSize: clamp(raw.highlighterSize, 8, 36, DEFAULT_WHITEBOARD_PREFS.highlighterSize),
    boardSurface: BOARD_SURFACE_OPTIONS.has(String(raw.boardSurface || "").trim())
      ? String(raw.boardSurface).trim()
      : DEFAULT_WHITEBOARD_PREFS.boardSurface,
    gridEnabled:
      raw.gridEnabled === undefined || raw.gridEnabled === null
        ? DEFAULT_WHITEBOARD_PREFS.gridEnabled
        : Boolean(raw.gridEnabled),
  };
}

export async function fetchWhiteboardPrefs() {
  const res = await fetch("/api/whiteboards/prefs", {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!res.ok) throw new Error("prefs_fetch_failed");
  const data = await res.json().catch(() => ({}));
  return normalizeWhiteboardPrefs(data?.prefs || {});
}

export async function patchWhiteboardPrefs(patch) {
  const res = await fetch("/api/whiteboards/prefs", {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(patch || {}),
  });
  if (!res.ok) throw new Error("prefs_patch_failed");
  const data = await res.json().catch(() => ({}));
  return normalizeWhiteboardPrefs(data?.prefs || {});
}

export { DEFAULT_WHITEBOARD_PREFS };
